import { render, staticRenderFns } from "./monthsSwitcher.vue?vue&type=template&id=0ff15a20&"
import script from "./monthsSwitcher.vue?vue&type=script&lang=js&"
export * from "./monthsSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports